import React from 'react'
import { Outlet } from 'react-router-dom'

const DonPage = () => {
  return (
    <Outlet />
  )
}

export default DonPage